<template>
    <b-card
            class="coach-meeting-header-card"
            @click="link()"
    >
        <div class="coach-meeting-header-card-content px-1">
            <div class="row no-gutters">
                <div class="col-1 coach-meeting-header-card-picto my-auto text-left">
                    <i class="fas fa-heartbeat" :style="getStylesheet(meeting)"/>
                </div>
                <div class="col-6 coach-meeting-header-card-infos pl-3">
                    <h2 class="text-left" :style="getStylesheet(meeting)">
                        {{name}}
                    </h2>
                    <p>
                        {{meeting.activite.ou.fullName}}
                    </p>
                </div>
                <div class="col-5 coach-meeting-header-card-period">
                    <p>
                        <i class="far fa-calendar-alt"/>
                        {{date.format('dddd DD[ / ]MM')}}
                    </p>
                    <p>
                        <i class="far fa-clock"/>
                        {{date.format('HH[h]mm')}} - {{ date.add(meeting.duration, 'm').format('HH[h]mm') }}
                    </p>
                </div>
            </div>
        </div>
    </b-card>
</template>
<script>
    import moment from 'moment'

    export default {
        name: 'meeting-byDay-detail',
        props: {
            meeting: Object
        },
        data: () => ({
            moment
        }),
        methods: {
            link() {
                this.$router.push({name: 'meeting', params: {id: this.meeting.id}})
            },
            getStylesheet(meeting) {
                const isMine = this.meeting.realCoach.id == this.user.id
                const isSoon = moment(meeting.dateheure.date).unix() > moment().unix()

                if (isMine && isSoon) return { color: '#FF9966' }
                if (!isMine && isSoon) return { color: '#333333' }
                if (isMine && !isSoon) return {}
            }
        },
        computed: {
            user() {
                return this.$store.state.base.account.information
            },
            name() {
                return [this.meeting.activite.typeactivite.name, this.meeting.activite.name, this.meeting.name]
                    .join(' ').replace('null', '')
            },
            date() {
                return moment(this.meeting.dateheure.date)
            }
        }
    }
</script>
